import { render, staticRenderFns } from "./gl-status-chip.vue?vue&type=template&id=13eaafa0&scoped=true"
import script from "./gl-status-chip.vue?vue&type=script&lang=js"
export * from "./gl-status-chip.vue?vue&type=script&lang=js"
import style0 from "./gl-status-chip.vue?vue&type=style&index=0&id=13eaafa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13eaafa0",
  null
  
)

export default component.exports